import { FC } from 'react'

type Props = {
  className?: string
}

const LogoCircleIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="16" cy="16" r="16" fill="#1D252D" />
      <path
        d="M15.3386 23.9987C13.9962 23.9987 12.0062 23.6315 10.8116 22.9497C11.038 22.4507 11.462 22.0889 12.0642 22.3983C13.0977 22.9393 14.255 23.2169 15.4284 23.2052C17.156 23.2052 18.4114 22.2638 18.3285 20.5423C18.1518 16.9515 10.6445 16.4068 10.6666 12.0925C10.6845 8.90645 13.5943 8 16.3827 8C17.7438 8.00301 19.091 8.26667 20.3476 8.77599C20.1239 9.29511 19.7469 9.72548 19.0826 9.41481C18.2051 8.99799 17.2416 8.78136 16.2653 8.78137C14.568 8.78137 13.604 9.68513 13.5971 11.0354C13.5792 14.4689 21.2066 14.9813 21.3309 19.4597C21.4234 22.6874 18.6627 24 15.3427 24"
        fill="white"
      />
    </svg>
  )
}

export default LogoCircleIcon
